import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductionProcessService {

  private url = environment.api + "api/erp/production-process";
  constructor(
    private http: HttpClient,
  ) { }

  createProductiveProcess(data: any) {
    return this.http.post(this.url+"/create", data);
  }

  executeProductionProcess(processId: number, data: any){
    return this.http.post(this.url+`/perform/${processId}`, data);
  }

  getAllProductionProcess(){
    return this.http.get(this.url+"/all");
  }

  getAllProductionProcessWithDetails(){
    return this.http.get(this.url+"/all/details");
  }

  getProductionProcessDetails(processId: number){
    return this.http.get(this.url+`/${processId}/details`);
  }

  updateProductionProcessVariousDetails(processId: number, data: any){
    return this.http.put(this.url+`/various-details/${processId}`, data);
  }

  updateQuantityCostProductionResult(productionDetailResultId: number, data: any){
    return this.http.put(this.url+`/process-result/${productionDetailResultId}`, data);
  }

  updateQuantityCostProductionDetail(productionDetailId: number, data: any){
    return this.http.put(this.url+`/process-detail/${productionDetailId}`, data);
  }

  deleteProductionProcess(processId: number){
    return this.http.delete(this.url+`/${processId}`);
  }

  deleteProductionProcessDetail(processId: number, detailId: number){
    return this.http.delete(this.url+`/details/${processId}/${detailId}`);
  }
}
